import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ManageLead = lazy(() => import('../components/ManageLead'));

const ssoEmbedLeadRoutes: RouteObject = {
  path: '/embed/leads',
  element: <ManageLead isEmbed={true} />,
};
export default ssoEmbedLeadRoutes;
